import { useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { store } from '../../redux/oldStore';
import { ServerResponse } from '../../utils/Server';
import Button from '../_Core/Button';

const EsignRecoverPasswordPage = () => {
  const query = useMemo(() => new URLSearchParams(window.location.search), []);
  const token = query.get('SignatureRequest') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [message, setMessage] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = () => {
    if (!token) {
      toast.error('Reset password has expired. Please request a new reset password.', { autoClose: false });
      return;
    }
    if (!password) {
      toast.error('Password is required.', { autoClose: false });
      return;
    }
    if (password !== confirm) {
      toast.error('Passwords do not match.', { autoClose: false });
      return;
    }

    setSaving(true);
    store.server
      .postApi<ServerResponse<string>>('../ProjectReview/EsignResetPassword', {
        signatureRequest: token,
        password,
      })
      .then((x) => {
        if (x.Success) {
          setDone(true);
          setMessage(typeof x.Value === 'string' ? x.Value : 'Password updated.');
        } else {
          toast.error(x.Message, { autoClose: false });
        }
      })
      .finally(() => setSaving(false));
  };

  return (
    <div className="main-body-page grow" data-testid="esign-recover-password-page">
      <div className="col-md-5 col-md-offset-3" style={{ float: 'none', margin: '0 auto' }}>
        {done ? (
          <div className="alert alert-info" data-testid="password-updated">
            <h4>Password Updated!</h4>
            <p>{message}</p>
          </div>
        ) : (
          <>
            <h4>Reset your password!</h4>
            {!token && (
              <div className="alert alert-danger" data-testid="missing-token">
                Reset password has expired. Please request a new reset password.
              </div>
            )}
            <div className="form-horizontal">
              <div className="form-group">
                <label className="col-sm-4 control-label" htmlFor="esign-new-password">
                  Password:
                </label>
                <div className="col-sm-8">
                  <input
                    id="esign-new-password"
                    type="password"
                    className="form-control"
                    data-testid="esign-new-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
              </div>
              <div className="form-group">
                <label className="col-sm-4 control-label" htmlFor="esign-confirm-password">
                  Confirm Password:
                </label>
                <div className="col-sm-8">
                  <input
                    id="esign-confirm-password"
                    type="password"
                    className="form-control"
                    data-testid="esign-confirm-password"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="col-sm-8 col-sm-offset-4">
                  <Button type="save" text={saving ? 'Saving...' : 'Reset Password'} onClick={submit} disabled={saving || !token} />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default EsignRecoverPasswordPage;
